module.exports = __webpack_public_path__ + "assets/img/returnBtn-01221ac0.png";